import React from 'react';
import ReactMarkdown from 'react-markdown';
import { cn } from '@/lib/utils';

interface MarkdownContentProps {
  content: string;
  className?: string;
}

export function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <div className={cn(
      "prose prose-sm max-w-none",
      "prose-headings:font-semibold prose-headings:text-gray-700",
      "prose-p:text-gray-600",
      "prose-a:text-blue-600 prose-a:no-underline hover:prose-a:underline",
      "prose-code:bg-gray-100 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:text-gray-800",
      "prose-blockquote:border-l-2 prose-blockquote:border-gray-300 prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600",
      "prose-ul:list-disc prose-ol:list-decimal prose-li:ml-4",
      className
    )}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}
